// TODO: SPT:REMOVE

export const selectAreasList = (state) => state.area.areasList;
